module.exports = __webpack_public_path__ + "static/media/search-icon.07d42071.svg";